<template>
  <div class="details">
    <div class="nuv">
      <a href="/tjkStudy/courseList" class="active">培训课程</a>&gt;<span>{{courseDetail.courseName}}</span>
    </div>
    <div class="box">
      <div class="left leftcour">
        <div class="details-box clear">
          <div :style="style(courseDetail.iconUrl)" class="zoomImage"></div>
          <div class="txt txt-over course-txt">
            <h2>{{courseDetail.courseName}}</h2>
            <div class="iconfont icon-yuyue1 text-float"><span><i>{{courseDetail.lessonPeriod}}</i>学时</span><span>|</span></div>
            <div class="iconfont icon-people text-float"><span>已有<i>{{courseDetail.totalUserNum}}</i>人学习</span></div>
            <div class="join" @click="startStudyCourse()">立即学习<template v-if="courseDetail.isDone == 'yes'">(已学)</template></div>
          </div>
        </div>
        <div class="list">
          <div class="cat-head">
            <a href="#present"  class="active">课程介绍</a>
            <a href="#catalog">课程目录</a>
          </div>
          <div class="present" id="present">
            <p v-html="courseDetail.description"></p>
          </div>
          <a href="javascript:;" class="top-head">课程目录</a>
          <div class="catalog" id="catalog">
            <ul>
              <li :class="{'active':(key+1)%2}" v-for="(m,key) in materialList" @click="studyCourse(m.materialId,m.courseId,courseDetail.courseName)"><span class="order">{{key+1}}、</span><img :src="m.resTypeUrl" class="resType"><span>{{m.catalogName}}</span><time v-if="m.duration != null">({{formatSeconds(m.duration)}})</time><div class="complete" v-if="m.isDone == 'yes'">已完成</div></li>
            </ul>
        </div>
        </div>
      </div>
      <div class="right">
        <h4 :title="'学习该课程的学员'+keys">学习该课程的学员（{{keys}}）</h4>
        <ul>
          <li v-for="infos in info">
            <img class="head" :src="infos.userIcon" /> 
            <p :title="infos.loginName">{{infos.loginName}}</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
  import play from './../assets/images/play.png'
  import pdf from './../assets/images/pdf.png'
  import word from  './../assets/images/word.png'
  import ppt from  './../assets/images/PPT.png'
  import Pagination from "../components/pagination.vue";
  export default {
    data() {
      return {
        "id": this.$route.params.id,//courseId
        "categoryId":'',
        "materialId":'',
        "materialList":'',//课件列表
        "completeMaterialList":'',//课件列表
        "info":'',
        "keys":0,
        "nextStudyMaterial":'',//下一个学习的课件
        'success': true,
        'courseDetail': {},
        "img":[
          {src:play},
          {src:pdf}
        ]
      }
    },
    mounted:function(){
      this.MaterialList()
      this.CourseDetail()
      this.StudyInfo()
    },
    methods: {
      //学习课程记录
      GetArgsFromHref:function(sArgName) {
        var sHref = window.location.href
        var args = sHref.split("?")
        var retval = ""
        if (args[0] == sHref) 
        {
          return retval
        }
        var str = args[1]
        args = str.split("&");
        for (var i = 0; i < args.length; i++) {
          str = args[i]
          var arg = str.split("=")
          if (arg.length <= 1) continue
          if (arg[0] == sArgName) retval = arg[1]
        }
        return retval
      },//获取url参数
      StudyInfo:function(){
        var data={
          "courseId":this.id,          
          size:20
        };
        this.$http.post(API_ROOT.system+'/course/study/queryUserStudyInfo',data).then(response=>{
          var result= response.data
          if(result.success){
            this.info= result.data
            this.keys=this.info.length
          }else{
            alert(result.msg)
          }
        },response => {
          alert('网络繁忙，请稍后重试！')
        })
      },//排行榜接口
      studyCourse:function(numb,courseId,courseName){
        var isCompletCourse = true;
        for(var i=0;i<this.materialList.length;i++){
          if(!this.materialList[i].isDone){
            isCompletCourse = false;
            break;
          }
        }
        // if(isCompletCourse){
        //   this.$http.post(API_ROOT.system+'/course/study/completeStudyCourse',{ "courseId":this.id}).then(response=>{
        //     var result=response.data
        //     if(result.success){
        //     }else{
        //       alert(result.msg)
        //     }
        //   },response=>{
        //     alert("网络繁忙，请稍后重试！")
        //   })
        // }
        this.$router.push({path:'/course?materialId='+numb+"&&courseId="+courseId+"&&courseName="+courseName})
        // var data={
        //   "courseId":this.id
        // }
        // this.$http.post(API_ROOT.system+"/course/study/startStudyCourse",data).then(response=>{
        //   var result= response.data
        //   if(result.success){
        //   }else{
        //     alert(result.msg)
        //   }
        // },response=>{
        //   alert("网络繁忙，请稍后重试！")
        // })
      },
      startStudyCourse:function(){
        for(var i=0;i<this.materialList.length;i++){
          if(this.materialList[i].materialId == this.nextStudyMaterial){
             this.studyCourse(this.nextStudyMaterial,this.courseDetail.courseId,this.courseDetail.courseName)
            break;
          }
        }
      },//开始课程学习

      queryUserMaterial:function(materialListParam){
        var data ={
          "courseId":this.id
        }
        this.$http.post(API_ROOT.system+'/course/study/queryUserMaterial',data).then(response=>{
          var result= response.data
          if(result.success){
            var completeMaterialMap = {};
            for(var i=0;i<result.data.length;i++){
              if(result.data[i].isDone=="yes"){
                completeMaterialMap[result.data[i].materialId] = result.data[i];
              }
            }
            this.completeMaterialList = result.data
            for(var n=0;n<materialListParam.length;n++){
                if(completeMaterialMap[materialListParam[n].materialId]){
                  materialListParam[n].isDone = 'yes'
                }

                if(this.nextStudyMaterial == '' && !completeMaterialMap[materialListParam[n].materialId]){
                  this.nextStudyMaterial = materialListParam[n].materialId
                }
            }
            if(this.nextStudyMaterial == ''){
              this.nextStudyMaterial = materialListParam[0].materialId
            }
            this.materialList = materialListParam;  
          }else{
            alert(result.msg)
          }
        },response=>{
          alert("网络繁忙，请稍后重试！")
        })
      },//学习课程课件记录信息

      CourseDetail:function(){
        var data={
          "courseId":this.id
        };
        this.$http.post(API_ROOT.system+'/course/study/queryCourseDetail',data).then(response=>{
          var result = response.data
          if(result.success){
            this.courseDetail = result.data
          }else {
            alert(result.msg)
          }
        },response => {
          alert('网络繁忙，请稍后重试！')
        })
      },//课程详细信息
      MaterialList:function(){
        var data={
          "courseId":this.id
        }
        this.$http.post(API_ROOT.system+'/course/study/queryMaterialList',data).then(response=>{
          var result=response.data;
          if(result.success){
            for(var i=0;i<result.data.length;i++){
              if(result.data[i].resourceType=='mp4'){
                result.data[i].resTypeUrl = this.img[0].src
              }else if(result.data[i].resourceType=='pdf'){
                result.data[i].resTypeUrl =  this.img[1].src
              }
            }
            if(result.data && result.data.length > 0){
              this.queryUserMaterial(result.data)
            }
          }else{
            alert(result.msg)
          }
        },response=>{
          alert("网络异常，请稍后重试！")
        })
      },//课件信息列表
      formatSeconds(value) {
        var result = ''
        var days = parseInt(value / ( 60 * 60 * 24));
        var hours = parseInt((value % ( 60 * 60 * 24)) / (60 * 60));
        if(hours > 0){
          hours = hours < 9 ? ('0'+hours):hours  
          result += hours + ':'
        }
        var minutes = parseInt((value % (60 * 60)) / (60));
        if(minutes > 0){
          minutes = minutes < 9 ? ('0'+minutes):minutes  
          result += minutes + ':'
        }
        var seconds = value % 60;
        if(seconds > 0){
          seconds = seconds < 9 ? ('0'+seconds):seconds  
          result += seconds 
        }
        return result
      },
      //设置封面图片
      style(iconUrl) {
        return {
          backgroundImage: 'url(' + iconUrl + ')'
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ./src/page/courseDetail.vue